import type { AssetFolderSummary } from "./asset-types";
import type { FolderPickRow } from "./folder-pick-list";

/**
 * The row list every `FolderPickList` mount builds the same way: folders
 * sorted alphabetically, with `Unsorted` pinned first — and, for the one
 * mount scoped across the whole picker rather than to a single asset or
 * upload (the folder menu, spec §5.3), `All` pinned ahead of that.
 *
 * Extracted because three call sites (`asset-picker.tsx`'s upload target,
 * `asset-tile-grid.tsx`'s move-to list, `folder-menu.tsx`'s own rows) built
 * this by hand — two of them byte-identical, the third differing only by the
 * leading `All` row — and a change to one (locale-aware collation, a
 * "recently used" pin) would otherwise silently disagree with the other two
 * (C2, final review). `fit-chips.ts` is this family's precedent for pulling
 * a tiny, testable piece out of a component for exactly this reason.
 */
export function buildFolderRows(
    folders: AssetFolderSummary[],
    options: { includeAll?: boolean } = {},
): FolderPickRow[] {
    const rows: FolderPickRow[] = [];
    if (options.includeAll) rows.push({ value: { mode: "all" }, label: "All" });
    rows.push({ value: { mode: "unsorted" }, label: "Unsorted" });
    for (const folder of [...folders].sort((a, b) => a.name.localeCompare(b.name))) {
        rows.push({ value: { mode: "folder", folderId: folder.id }, label: folder.name });
    }
    return rows;
}
